<div class="header">
  <div class="title-wrapper">
    <h2 [class.required]="highlightRequired">{{ title }}{{ module.minPickCount > 0 ? '*' : '' }}</h2>
    @if (pickCountLabel) {
      <span>{{ pickCountLabel }}</span>
    }
  </div>
  <div class="selected-labels">
    @if (type !== 'add') {
      @for (product of module.products; track product.id) {
        @if (composition && !!composition?.moduleChoices[module.id]?.products[product.id]?.quantity) {
          <button class="selected-product unstyled-button" (click)="removeProduct(product, 1)">
            {{ product.productDisplayName }} <mat-icon svgIcon="delete"></mat-icon>
          </button>
        }
      }
    }
    @if (highlightRequired) {
      <span class="pick-count-warning">{{ pickCountWarningLabel }}</span>
    }
  </div>
</div>
<ul class="modules unstyled">
  @for (product of module.products; track product.id) {
    @let quantity = type === 'add' && composition ? composition?.moduleChoices[module.id]?.products[product.id]?.quantity : undefined;
    @let picked = type !== 'add' && composition && !!composition?.moduleChoices[module.id]?.products[product.id]?.quantity;
    @if (!pictureCards) {
      <app-product-card
        [product]="product"
        [baseCard]="true"
        [selectLabel]="selectLabel"
        [selectedLabel]="selectedLabel"
        [quantity]="quantity"
        [picked]="picked"
        [clearable]="composition.minCount < 1"
        [locked]="locked"
        (add)="addProduct(product, $event)"
        (remove)="removeProduct(product, $event)"
        [small]="true"
        [moduleType]="type"
        [hideImage]="hideImages"
      ></app-product-card>
    }
    @if (pictureCards) {
      <div class="picture-card">
        <img [srcset]="product | productSizes: true" [src]="product | primary" [alt]="product.productDisplayName" />
        <b class="product-card-name">{{ product.productDisplayName }}</b>
        <div class="buttons">
          @if (!quantity && !picked) {
            <app-text-button [disabled]="locked" (click)="addProduct(product, product.minCount)">
              {{ selectLabel }}
            </app-text-button>
          }
          @if (!quantity && picked) {
            <div class="picked-button">
              <app-text-button>{{ selectedLabel }}</app-text-button>
              <app-icon-button
                class="clear-selected"
                [icon]="clearSelectionIcon"
                [disabled]="locked"
                [border]="false"
                (click)="removeProduct(product, 1)"
              ></app-icon-button>
            </div>
          }
          @if (quantity) {
            <app-counter
              [count]="quantity"
              [minCount]="product.minCount"
              [lockAdd]="locked"
              [lockRemove]="locked"
              (add)="addProduct(product, $event.quantity)"
              (remove)="removeProduct(product, $event.quantity)"
            ></app-counter>
          }
        </div>
      </div>
    }
  }
</ul>
